<template>
    <Modal size="md" @close="$emit('close')">
        <template #header>
            <div class="text-gray-600">Edit account details</div>
        </template>

        <template #body>
            <div class="flex flex-col gap-4 p-6">
                <TextInput
                    v-model="form.name"
                    label="Name"
                    required
                    :error="form.errors.name"
                />

                <TextInput
                    v-model="form.email"
                    label="Email"
                    type="email"
                    required
                    :error="form.errors.email"
                />

                <p class="text-sm text-gray-500">
                    The new email is marked verified immediately — no
                    verification email is sent. The previous address is notified
                    of the change.
                </p>
            </div>
        </template>

        <template #footer>
            <div class="flex justify-end border-t border-gray-200 p-6">
                <AtomicButton
                    color="white"
                    size="md"
                    :disabled="form.processing"
                    @click="$emit('close')"
                >
                    Cancel
                </AtomicButton>

                <AtomicButton
                    size="md"
                    color="yellow"
                    class="ml-2"
                    :disabled="form.processing"
                    @click="submit"
                >
                    {{ form.processing ? 'Saving...' : 'Save' }}
                </AtomicButton>
            </div>
        </template>
    </Modal>
</template>

<script lang="ts" setup>
import Modal from '@/components/Atomic/Modals/Modal.vue';
import AtomicButton from '@/components/Atomic/Buttons/AtomicButton.vue';
import TextInput from '@/components/Atomic/Inputs/TextInput.vue';
import { useForm } from '@inertiajs/vue3';
import { route } from 'ziggy-js';
import { create } from '@/composables/useNotifications';
import IKioskUser from '@/types/Members/IKioskUser';

const props = defineProps<{
    selectedUser: IKioskUser;
}>();

const emit = defineEmits(['close']);

const form = useForm({
    name: props.selectedUser.name,
    email: props.selectedUser.email,
});

const submit = () => {
    form.put(
        route('kiosk.users.account-details.update', {
            user: props.selectedUser.id,
        }),
        {
            preserveScroll: true,
            onSuccess: () => {
                create({
                    title: 'Account details updated',
                    type: 'success',
                });
                emit('close');
            },
            onError: () => {
                create({
                    title: 'Account details not updated',
                    text: 'There was an error updating account details.',
                    type: 'error',
                });
            },
        }
    );
};
</script>
